export class SocialProfile{
    public id: number = 0;
    public name: string = '';
    public profileLink: string = '';
}